import { get } from '../xhr/index'

// GET a number of pending requests for the notification
export const notificationAPI = async () => {
  return get('/transactions/notification')
}
